module.exports = __webpack_public_path__ + "static/img/logo2.5c225b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/logo2.png
// module id = SXH+
// module chunks = 0